import { render, staticRenderFns } from "./PaginationProRetoucher.vue?vue&type=template&id=db078882&"
import script from "./PaginationProRetoucher.vue?vue&type=script&lang=js&"
export * from "./PaginationProRetoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports